export default __webpack_public_path__ + "static/media/add-on-icon.e5fe40ee.svg";